<template>
    <div>
        <input type="text" class="input m-b-sm" v-model="searchText" :placeholder="$t('Search terms')" @keyup.enter="search" >
        <label  v-for="item in categories" :key="item" class="checkbox is-inline-block" style="width: 50%;">
            <input @click="update(item)" type="checkbox" class="m-r-sm" :checked="selectedCategories.indexOf(item) >= 0">
            {{ $t(item) }}
        </label>
        <div class="is-fullwidth has-text-right p-t-sm">
            <button class="button m-r-md" @click="$emit('cancel')">{{ $t('Cancel') }}</button>
            <button class="button is-primary m-r-md" @click="search">{{ $t('Search') }}</button>
        </div>
    </div>
</template>


<script>
export default {
  name: 'ReciptSearch',
  props: ['data'],
  data () {
    const search = this.$store.getters.getSearch
    return {
        searchText: search.terms.length > 0 ? search.terms.concat(' ') : null,
        categories: ['Breakfast', 'Lunch', 'Dinner', 'Vegan', 'Drink', 'Snacks'],
        selectedCategories: search.tags
    }
  },
  methods: {
      update (item) {
          let isInArray = false
          this.selectedCategories = this.selectedCategories.reduce((arr, n) => {
              if (n !== item) arr.push(n)
              else isInArray = true
              return arr
          }, [])
          if ( ! isInArray) this.selectedCategories.push(item)
      },
      search () {
          this.$store.commit('setSearchTerm', this.searchText)
          this.$store.commit('setSearchTags', this.selectedCategories)
          this.$router.push({ name: 'ReciptFind' })
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/ReciptSearch.vue